import { setCurrentStore, setOpenClusterDetail, setAddress } from '@state/features/storelocator.slice';
import analytics from '@utils/analytics';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useSwipeable } from 'react-swipeable';
import StoreAvailableServices from './StoreAvailableServices';
import StoreBoutiqueCollections from './StoreBoutiqueCollections';
import StoreBoutiqueInformation from './StoreBoutiqueInformation';
import StoreSummary from './StoreSummary';
import Icon from '@stone/ui/icon/Icon';
import { autoChooseClassnames, getId } from '@common/utils/brandDiffsUtils';
const StoreDetails = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { store, filteredStores } = props;
    const { baseUrl, openClusterDetail, storesInMap } = useSelector((state) => state.storelocator);
    const [storeOpen, setStoreOpen] = useState(false);
    const [clusterStores, setClusterStores] = useState(filteredStores);
    const handlers = useSwipeable({
        trackMouse: true,
        preventScrollOnSwipe: true,
        onSwipedDown: () => setStoreOpen(false),
        onSwipedUp: () => setStoreOpen(true),
    });
    const findCommonStoreName = (str1 = '', str2 = '') => {
        const common = [];
        let i, j, part;
        for (i = 0; i < str1.length - 1; i++) {
            for (j = i + 1; j <= str1.length; j++) {
                part = str1.slice(i, j);
                if (str2.indexOf(part) !== -1) {
                    common.push(part);
                }
            }
        }
        return common.reduce((prev, current) => (prev.length > current.length ? prev : current));
    };
    useEffect(() => {
        if (openClusterDetail) {
            setClusterStores(filteredStores);
            setStoreOpen(true);
        }
    }, [openClusterDetail]);
    const handleStoreClosed = () => {
        dispatch(setCurrentStore(undefined));
        dispatch(setOpenClusterDetail(false));
        if (storesInMap.includes(store)) {
            dispatch(setAddress(store.address1));
        }
        else {
            dispatch(setAddress(undefined));
        }
    };
    return (React.createElement("div", { role: "dialog", "aria-modal": "false", className: classNames('store', { open: storeOpen }), onKeyDown: (e) => {
            if (e.key == 'Escape') {
                handleStoreClosed();
            }
        }, "aria-labelledby": "storeDetailTitle" },
        React.createElement("button", { className: autoChooseClassnames({
                MO: 'icon--close',
                ST: 'button--close',
            }), type: "button", "aria-label": t('button.close'), autoFocus: true, onClick: () => {
                handleStoreClosed();
            } }, getId() === 'ST' && React.createElement(Icon, { name: "close", family: "16" })),
        React.createElement("div", { className: "store-wrapper" },
            React.createElement("div", Object.assign({ className: "store__summary" }, handlers),
                React.createElement("div", { className: "container" },
                    React.createElement("h2", { className: "store__summary__name", id: "storeDetailTitle" },
                        openClusterDetail && store && (React.createElement("button", { className: "back-to-cluster icon--arrow-left-black", "aria-label": t('storelocator.backtocluster'), onClick: () => {
                                dispatch(setCurrentStore(undefined));
                                setStoreOpen(true);
                            } })),
                        store ? store === null || store === void 0 ? void 0 : store.name : openClusterDetail && (findCommonStoreName(clusterStores[0].name, clusterStores[1].name) || t('storelocator.samebuilding'))),
                    (store === null || store === void 0 ? void 0 : store.notificationBanner) && React.createElement("div", { className: "store__summary__notification-banner" }, store.notificationBanner),
                    store && (React.createElement(React.Fragment, null,
                        React.createElement(StoreSummary, { store: store }),
                        React.createElement("a", { href: `${baseUrl}/storelocator/${store.slug}`, onClick: () => analytics.storelocatorAction(store.name, 'view detail'), className: "button button--link button--arrow-right store__summary__viewmore" }, t('button.viewdetails')))))),
            React.createElement("div", { className: "store__moreinfo" },
                React.createElement("div", { className: "container" }, store ? (React.createElement(React.Fragment, null,
                    React.createElement(StoreBoutiqueInformation, Object.assign({ store: store }, props)),
                    store.storeCollections && React.createElement(StoreBoutiqueCollections, { collections: store.storeCollections }),
                    store.hasInStoreServices && React.createElement(StoreAvailableServices, { services: store.storeServices }))) : (openClusterDetail &&
                    clusterStores.map((store, i) => (React.createElement("div", { key: i, className: "store-in-cluster" },
                        React.createElement("h3", { className: "store__summary__name" }, store.name),
                        React.createElement("button", { className: "button button--secondary", onClick: () => {
                                analytics.storelocatorSelect(store.name);
                                dispatch(setCurrentStore(store.ID));
                                setStoreOpen(false);
                            } }, t('storelocator.choose')))))))))));
};
export default StoreDetails;
